export enum RoutesEnum {
  LOGIN = '/login',
  DASHBOARD = '/dashboard',
  STOCK = '/stock',
  INFLOWS = '/inflows',
  OUTFLOWS = '/outflows',
  USERS = '/users',
  USERS_CREATE = '/users/create',

  PRODUCTS = '/stock/products',
  PRODUCTS_CREATE = '/stock/products/create',
  CLIENTS = '/inflows/clients',
  CLIENTS_CREATE = '/inflows/clients/create',
  SALES = '/inflows/sales',
  SALES_CREATE = '/inflows/sales/create',
  SALE_DETAIL = '/inflows/sales/detail',
  PROVIDERS = '/outflows/providers',
  PROVIDERS_CREATE = '/outflows/providers/create',
  PURCHASES = '/outflows/purchases',
  PURCHASES_CREATE = '/outflows/purchases/create',
  PAYMENTS = '/inflows/payments',
  PAYMENTS_CREATE = '/inflows/payments/create',
  COMBINATIONS = '/stock/combinations',
  COMBINATIONS_CREATE = '/stock/combinations/create',
  DAILY_CASH_CLOSING = '/inflows/daily-cash-closing',
  ORDERS_ACTIVES = '/inflows/orders-actives',
}
